import React from "react";
import { DragDropContext, Droppable,  } from "react-beautiful-dnd";
import "./Supersets.scss";
import SupersetNoSearch from "../Superset/supersetNoSearch";

export default function SupersetsNoSearch({supersetName, previousValues, isPersonal, supersets, setName, isAdmin,  error, exercises, setSupersets, removeExercise, removeSet, onDragEnd, onClickSearch, onChange}) {

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="sets" type="parent">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {supersets.map((item, idx) => (
              <SupersetNoSearch previousValues={previousValues} setName={setName} isPersonal={isPersonal} isAdmin={isAdmin} exercises={exercises} error={error} set={item} set_idx={idx} removeSet={(e) => removeSet(e)} removeExercise={removeExercise} onClickSearch={onClickSearch} onChange={onChange}/>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
